import swapIcon from '../assets/images/wealthandsavingsnav/Swap (1).svg';
import percentIcon from '../assets/images/wealthandsavingsnav/Percent (1).svg';
import shieldCheckIcon from '../assets/images/wealthandsavingsnav/ShieldCheck (2).svg';
import stackIcon from '../assets/images/wealthandsavingsnav/Stack (1).svg';
import chartLineUpIcon from '../assets/images/wealthandsavingsdetails/coreparametres/ChartLineUp.svg';
import lockOpenIcon from '../assets/images/wealthandsavingsdetails/coreparametres/LockOpen.svg';
import swapTransferIcon from '../assets/images/wealthandsavingsdetails/coreparametres/Swap (1).svg';

export const wealthProducts = [
  {
    slug: 'active-saving-account',
    category: 'Wealth & Savings',
    tagline: 'Maximum Flexibility',
    title: 'Active Saving Account',
    heroTitle: 'Active Saving Account:\nLiquidity Meets Growth.',
    cardText:
      'Earn competitive returns while maintaining full, instant access to your capital. Ideal for liquidity management.',
    heroDescription:
      'Maintain immediate access to your capital while earning competitive, risk-managed returns. The perfect balance for capital that needs to remain agile.',
    cta: 'Open an Active Account',
    icon: swapIcon,
    earnTitle: 'Earn Without Being Locked In.',
    earnParagraphs: [
      'Traditional high-yield accounts often require long-term commitments. The VBS Active Saving Account is designed for the modern investor who values liquidity above all.',
      'Whether you are waiting for the right market opportunity or managing corporate cash flow, your funds stay productive without early withdrawal penalties or complex restrictions.',
    ],
    coreParameters: [
      {
        title: 'Flexible Yield',
        text: 'Keep your capital productive with competitive rates that reflect the current market environment.',
        icon: chartLineUpIcon,
      },
      {
        title: 'Zero Lock-in',
        text: 'No fixed terms. Your funds are available 24/7, providing the agility you need for tactical financial moves.',
        icon: lockOpenIcon,
      },
      {
        title: 'Instant Transfers',
        text: 'Move funds between your Active Saving account and other VBS platforms instantly and securely.',
        icon: swapTransferIcon,
      },
    ],
    savingsQuote:
      '“Your savings are managed through our secure institutional infrastructure. We prioritize capital preservation by allocating funds into highly liquid, low-risk environments, ensuring that your balance is protected and always available for withdrawal.”',
    accountFeatures: [
      { label: 'Minimum Deposit:', value: '$10,000' },
      { label: 'Withdrawal Notice:', value: 'None (Instant access).' },
      {
        label: 'Compounding:',
        value: 'Returns calculated daily and credited monthly.',
      },
      {
        label: 'Reporting:',
        value: 'Real-time digital dashboard + monthly statements.',
      },
    ],
    growthTitle: 'Agile Capital. Reliable Growth.',
    growthText:
      'Open your Active Saving Account in minutes and start optimizing your liquidity.',
    growthCta: 'Open a Saving Account',
  },
  {
    slug: 'interest-account',
    category: 'Wealth & Savings',
    tagline: 'Guaranteed Stability',
    title: 'Interest Account',
    heroTitle: 'Interest Account:\nPredictable, Protected Returns.',
    cardText:
      'Fixed-term solutions offering predictable and stable returns with maximum protection against market volatility.',
    heroDescription:
      'Lock in guaranteed interest over a defined term, with capital protection designed to keep your savings stable through changing market conditions.',
    cta: 'Open an Interest Account',
    icon: percentIcon,
    earnTitle: 'Earn With Defined Certainty.',
    earnParagraphs: [
      'The VBS Interest Account is built for capital that needs a predictable path. Fixed terms and protected returns give you clarity over both yield and timeline.',
      'Whether you are parking reserves or planning a known outflow, your savings remain productive within a structure designed for stability rather than speculation.',
    ],
    coreParameters: [
      {
        title: 'Guaranteed Yield',
        text: 'Lock in a defined rate for the term of your account, so returns stay predictable through changing market conditions.',
        icon: chartLineUpIcon,
      },
      {
        title: 'Defined Term',
        text: 'Choose a horizon that matches your plans, with capital held in a structure designed for stability rather than daily access.',
        icon: lockOpenIcon,
      },
      {
        title: 'Capital Protection',
        text: 'Keep principal protected while interest accrues, with a clear path from deposit through to maturity.',
        icon: swapTransferIcon,
      },
    ],
    savingsQuote:
      '“Your interest account is managed through our secure institutional infrastructure. We prioritize capital preservation by allocating funds into defined, low-risk environments, so your principal remains protected through to maturity.”',
    accountFeatures: [
      { label: 'Minimum Deposit:', value: '$25,000' },
      { label: 'Withdrawal Notice:', value: 'At term maturity.' },
      {
        label: 'Compounding:',
        value: 'Fixed interest accrued over the selected term.',
      },
      {
        label: 'Reporting:',
        value: 'Digital dashboard + statements at opening and maturity.',
      },
    ],
    growthTitle: 'Defined Terms. Reliable Growth.',
    growthText:
      'Open your Interest Account in minutes and start locking in a predictable return.',
    growthCta: 'Open a Saving Account',
  },
  {
    slug: 'isa-solutions',
    category: 'Wealth & Savings',
    tagline: 'Tax-Efficient Growth',
    title: 'ISA Solutions',
    heroTitle: 'ISA Solutions:\nTax-Efficient Long-Term Growth.',
    cardText:
      'Specialized tax-efficient savings vehicles designed to maximize your long-term growth.',
    heroDescription:
      'Structure your savings within a tax-efficient wrapper so more of your return compounds over time, aligned with your long-term wealth objectives.',
    cta: 'Open an ISA',
    icon: shieldCheckIcon,
    earnTitle: 'Earn More By Keeping More.',
    earnParagraphs: [
      'VBS ISA Solutions are designed so a larger share of your return stays with you. A tax-efficient wrapper helps long-term savings compound with less leakage.',
      'Whether you are building personal wealth or planning a longer horizon, your capital remains structured for growth without unnecessary tax friction.',
    ],
    coreParameters: [
      {
        title: 'Tax Efficiency',
        text: 'Keep more of what you earn inside a wrapper designed to reduce leakage and support long-term compounding.',
        icon: chartLineUpIcon,
      },
      {
        title: 'Compound Growth',
        text: 'Structure contributions and returns so gains can build over time within the ISA framework.',
        icon: lockOpenIcon,
      },
      {
        title: 'Long-Term Horizon',
        text: 'Align your ISA with a multi-year plan, from annual allowances through to later wealth objectives.',
        icon: swapTransferIcon,
      },
    ],
    savingsQuote:
      '“Your ISA is managed through our secure institutional infrastructure. We prioritize long-term compounding within a tax-efficient wrapper, so more of your return stays aligned with your wealth objectives.”',
    accountFeatures: [
      { label: 'Minimum Deposit:', value: '$10,000' },
      { label: 'Annual Allowance:', value: 'Subject to current ISA limits.' },
      {
        label: 'Compounding:',
        value: 'Returns calculated daily and credited monthly.',
      },
      {
        label: 'Reporting:',
        value: 'Real-time digital dashboard + annual tax statements.',
      },
    ],
    growthTitle: 'Tax-Efficient. Reliable Growth.',
    growthText:
      'Open your ISA in minutes and start compounding with a more efficient wrapper.',
    growthCta: 'Open a Saving Account',
  },
  {
    slug: 'structured-savings',
    category: 'Wealth & Savings',
    tagline: 'Strategic Planning',
    title: 'Structured Savings',
    heroTitle: 'Structured Savings:\nStrategy for Defined Milestones.',
    cardText:
      'Custom-built savings strategies tailored to specific financial milestones and long-term capital objectives.',
    heroDescription:
      'Build a savings plan around specific goals and time horizons, with a structured path designed to preserve capital while progressing toward each milestone.',
    cta: 'Open a Structured Account',
    icon: stackIcon,
    earnTitle: 'Earn Toward a Defined Outcome.',
    earnParagraphs: [
      'VBS Structured Savings are built around specific milestones rather than open-ended accumulation. Each plan is shaped to the timeline and objective you are working toward.',
      'Whether you are funding a project or building toward a longer-term goal, your capital stays aligned with a clear path instead of a one-size-fits-all account.',
    ],
    coreParameters: [
      {
        title: 'Milestone Design',
        text: 'Shape the savings path around a specific goal, amount, and date rather than an open-ended balance.',
        icon: chartLineUpIcon,
      },
      {
        title: 'Custom Terms',
        text: 'Set contribution cadence and structure to the timeline you are working toward.',
        icon: lockOpenIcon,
      },
      {
        title: 'Goal Alignment',
        text: 'Keep capital allocated to the outcome it is meant to fund, with a clear plan from start to completion.',
        icon: swapTransferIcon,
      },
    ],
    savingsQuote:
      '“Your structured savings are managed through our secure institutional infrastructure. We prioritize capital preservation while keeping each allocation aligned with the milestone and timeline it is designed to fund.”',
    accountFeatures: [
      { label: 'Minimum Deposit:', value: 'By arrangement.' },
      { label: 'Term Structure:', value: 'Aligned to the defined milestone.' },
      {
        label: 'Compounding:',
        value: 'Returns scheduled to the plan’s contribution path.',
      },
      {
        label: 'Reporting:',
        value: 'Digital dashboard + milestone progress statements.',
      },
    ],
    growthTitle: 'Planned Capital. Reliable Growth.',
    growthText:
      'Open a Structured Savings plan in minutes and start funding the milestone ahead.',
    growthCta: 'Open a Saving Account',
  },
];

export const getWealthProductBySlug = (slug) =>
  wealthProducts.find((product) => product.slug === slug);
